import styled, { css, keyframes } from 'styled-components';
import { DEFAULT_COLORS } from 'components/core/colors';
import { DsoModalSize } from './DsoModal.types';

const sizeWidthMap: Record<DsoModalSize, string> = {
  sm: '400px',
  md: '520px',
  lg: '700px',
  xl: '800px',
  full: '100%',
};

export const getContentWidth = (
  size?: DsoModalSize,
  width?: string
): string => {
  if (width) return width;
  if (size) return sizeWidthMap[size];
  return sizeWidthMap.md;
};

const fadeIn = keyframes`
  from { opacity: 0; }
`;

const scaleIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.95);
  }
`;

export const Overlay = styled.div<{ $centered?: boolean }>`
  position: fixed;
  inset: 0;
  background: ${DEFAULT_COLORS.overlay};
  z-index: 100;
  display: flex;
  justify-content: center;
  animation: ${fadeIn} 200ms ease-out;
  overflow-y: auto;

  ${({ $centered }) =>
    $centered
      ? css`
          align-items: center;
        `
      : css`
          align-items: flex-start;
          padding-top: 60px;
          padding-bottom: 40px;
        `}
`;

export const Content = styled.div<{
  $width: string;
  $centered?: boolean;
}>`
  background: ${DEFAULT_COLORS.surface.white};
  border-radius: 8px;
  width: ${({ $width }) => $width};
  max-width: calc(100% - 32px);
  position: relative;
  animation: ${scaleIn} 250ms ease-out;
  box-shadow: 0 8px 30px ${DEFAULT_COLORS.grey12};

  ${({ $centered }) =>
    !$centered &&
    css`
      margin: auto 0;
    `}
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid ${DEFAULT_COLORS.surface.hover};
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Title = styled.h2`
  font-size: 1.2rem;
  font-weight: 600;
  color: ${DEFAULT_COLORS.ink.darkest};
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: ${DEFAULT_COLORS.sky.medium};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background 150ms ease;

  &:hover {
    background: ${DEFAULT_COLORS.surface.divider};
    color: ${DEFAULT_COLORS.ink.dark};
  }
`;

export const Body = styled.div`
  padding: 24px;
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
`;

export const LoadingBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 40px;
  gap: 20px;
`;

export const LoadingText = styled.p`
  text-align: center;
  color: ${DEFAULT_COLORS.grey60};
  font-size: 0.95rem;
  line-height: 1.5;
  margin: 0;
`;
